/**
 * Camera framing for pack-opening 3D scenes. Driven by the canvas size,
 * not the user-agent, so a small leftover-pack widget also gets a tight frame.
 */
export type PackFrame = 'wide' | 'portrait' | 'short'

/**
 * Classify a WebGL host so pack / vault cameras can keep the action on screen.
 */
export function packFrame(width: number, height: number): PackFrame {
  const w = Math.max(1, width)
  const h = Math.max(1, height)
  const aspect = w / h
  if (h <= 500 && aspect >= 1.12) return 'short'
  if (aspect < 0.92 || w <= 520) return 'portrait'
  return 'wide'
}

/**
 * Vertical FOV that fits a world box of `fitWidth` x `fitHeight` at `distance`.
 */
export function fitFov(
  aspect: number,
  distance: number,
  fitWidth: number,
  fitHeight: number,
  minFov = 32,
  maxFov = 56,
): number {
  const dist = Math.max(0.2, distance)
  const fovV = (2 * Math.atan(fitHeight / 2 / dist) * 180) / Math.PI
  const fovH = (2 * Math.atan(fitWidth / 2 / dist) * 180) / Math.PI
  const fovFromH =
    (2 * Math.atan(Math.tan((fovH * Math.PI) / 360) / Math.max(0.2, aspect)) *
      180) /
    Math.PI
  return Math.min(maxFov, Math.max(minFov, Math.max(fovV, fovFromH)))
}
